import axiosClient from "@/api/axios";
import { parseError } from "@/api/utils";
import type { ErrorType } from "@/api/utils";
import { OrderStatusType, OrderType } from "@/models/order";
const VITE_API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const PendingOrderStatusSet = new Set<OrderStatusType>([
  "pending",
  "checkout-draft",
]);

export function isPendingOrderStatus(status: OrderStatusType): boolean {
  return PendingOrderStatusSet.has(status);
}

type GetOrderResult =
  | { status: "completed"; data: OrderType }
  | { status: "aborted" }
  | { status: "error"; error: ReturnType<typeof parseError> };

type GetOrdersResult =
  | { status: "completed"; data: OrderType[] }
  | { status: "aborted" }
  | { status: "error"; error: ReturnType<typeof parseError> };

export const getOrder = async ({
  aController,
  order_id,
}: {
  order_id: string;
  aController: AbortController;
}): Promise<GetOrderResult> => {
  try {
    const response = await axiosClient({
      method: "GET",
      url: `${VITE_API_BASE_URL}/orders/${order_id}`,
      signal: aController.signal,
    });

    if (!response) {
      throw new Error("Failed to fetch order status");
    }
    return { status: "completed", data: response.data };
  } catch (error: any) {
    if (error.name === "AbortError" || error.code === "ERR_CANCELED") {
      return { status: "aborted" };
    }
    return { status: "error", error: parseError(error as ErrorType) };
  }
};

export const getOrders = async ({
  aController,
}: {
  aController: AbortController;
}): Promise<GetOrdersResult> => {
  try {
    const response = await axiosClient({
      method: "GET",
      url: `${VITE_API_BASE_URL}/orders`,
      signal: aController.signal,
    });

    if (!response) {
      throw new Error("Failed to fetch orders status");
    }
    return { status: "completed", data: response.data };
  } catch (error: any) {
    if (error.name === "AbortError" || error.code === "ERR_CANCELED") {
      return { status: "aborted" };
    }
    return { status: "error", error: parseError(error as ErrorType) };
  }
};
